import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
interface FormSuccessProps {
  title: string;
  text: string;
  resetLabel: string;
  onReset: () => void;
}
export function FormSuccess({
  title,
  text,
  resetLabel,
  onReset
}: FormSuccessProps) {
  const headingRef = useRef<HTMLHeadingElement>(null);
  useEffect(() => headingRef.current?.focus(), []);
  return <motion.div role="status" initial={{
    opacity: 0,
    scale: 0.97
  }} animate={{
    opacity: 1,
    scale: 1
  }} transition={{
    duration: 0.24,
    ease: [0.23, 1, 0.32, 1]
  }} className="rounded-2xl border border-plum/10 bg-white p-8 sm:p-10" data-id="element-168" data-mp="3c4xwmbevh20r">
      <span className="flex h-12 w-12 items-center justify-center rounded-full bg-aubergine text-copper-light" data-id="element-169" data-mp="3pwvwrwqlvnks">
        <CheckIcon className="h-6 w-6" aria-hidden="true" data-id="element-170" data-mp="3ux06n3x0dk21" />
      </span>
      <h3 ref={headingRef} tabIndex={-1} className="mt-6 text-2xl font-semibold text-aubergine focus:outline-none" data-id="element-171" data-mp="3pxfudl31fsc">
        {title}
      </h3>
      <p className="mt-3 max-w-prose leading-relaxed text-plum/70" data-id="element-172" data-mp="hvf9po2f51ju">{text}</p>
      <button type="button" onClick={onReset} className="mt-6 text-sm font-semibold text-copper-deep hover:text-plum" data-id="element-173" data-mp="curhiz2geeo1">
        {resetLabel}
      </button>
    </motion.div>;
}